import React from 'react'
import AdminUsersTable from "./AdminUsersTable"
import AdminHeader from "./AdminHeader"
import {useBreadcrumbs} from "../layouts/Nav/BreadcrumbsProvider"

function AdminUsersPage() {
    useBreadcrumbs([{label: "Users"}])
    return (
        <>
            <AdminHeader/>
            <AdminUsersTable />
        </>
    );
}

export default AdminUsersPage;